import { render } from "./AnnualProduction.vue?vue&type=template&id=029b8bb0"
import script from "./AnnualProduction.vue?vue&type=script&lang=ts"
export * from "./AnnualProduction.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
